module.exports = __webpack_public_path__ + "img/error404.ed960247.png";